/**
 * Alguns backends retornam `audits` como mapa (objeto) em vez de array.
 * Sem normalização, o grupo some da lista porque `Array.isArray` falha.
 *
 * @param {unknown} audits
 * @returns {Array<Record<string, unknown>>}
 */
export function normalizeAuditsToArray(audits) {
  let list = [];
  if (Array.isArray(audits)) {
    list = audits;
  } else if (audits != null && typeof audits === "object") {
    list = Object.values(audits);
  } else {
    return [];
  }
  // Backend pode enviar blocos agrupados (ex.: arrays por tipo); achatar um nível.
  return list.flatMap((entry) => (Array.isArray(entry) ? entry : [entry]));
}
